"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryWorkOrder = exports.cancelWorkOrder = exports.approveWorkOrder = exports.createWorkOrder = exports.getWorkOrder = void 0;

var field_1 = __importDefault(require("../field"));

var unit_1 = __importDefault(require("./unit"));

var http_1 = require("./http");

var uri = '/v4/data/units/';
/**
 * This function gets or sets a work order
 * @param uuid The UUID of the unit in question
 * @param id The ID of the work order in question
 * @param credentials The credentials needed for the request
 */

function getWorkOrder(uuid, id, credentials) {
  return unit_1.default(uuid, new Date(0), [field_1.default.WorkOrders], credentials).then(function (units) {
    var e_1, _a;

    try {
      for (var _b = __values(units[0].workorders), _c = _b.next(); !_c.done; _c = _b.next()) {
        var wo = _c.value;

        if (wo.Id === id) {
          return wo;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return {};
  });
}

exports.getWorkOrder = getWorkOrder;

function createWorkOrder(uuid, order, credentials, approve) {
  order.data = JSON.stringify(order.data); // maybe skip this for v4 api?

  var options = "";

  if (approve) {
    options = "?approve=true";
  }

  return http_1.authorizedHTTP(credentials).post(uri + uuid.string() + "/wo" + options, order, {
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  });
}

exports.createWorkOrder = createWorkOrder;

function approveWorkOrder(uuid, id, order, credentials) {
  order.data = JSON.stringify(order.data); // maybe skip this for v4 api?

  return http_1.authorizedHTTP(credentials).put(uri + uuid.string() + "/wo/" + id + "/approve", order, {
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  });
}

exports.approveWorkOrder = approveWorkOrder;

function cancelWorkOrder(uuid, id, order, credentials) {
  order.data = JSON.stringify(order.data); // maybe skip this for v4 api?

  return http_1.authorizedHTTP(credentials).put(uri + uuid.string() + "/wo/" + id + "/cancel", order, {
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  });
}

exports.cancelWorkOrder = cancelWorkOrder;

function retryWorkOrder(uuid, id, order, credentials) {
  order.data = JSON.stringify(order.data); // maybe skip this for v4 api?

  return http_1.authorizedHTTP(credentials).put(uri + uuid.string() + "/wo/" + id + "/retry", order, {
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  });
}

exports.retryWorkOrder = retryWorkOrder;